import React from "react";
import { Link } from "react-router-dom";
import { Plus, Facebook, Twitter, Linkedin } from "lucide-react";
import { team } from "../mock";
import { SectionLabel, Reveal } from "../components/common";

export const TeamCard = ({ m }) => (
  <div className="group">
    <div className="relative overflow-hidden rounded-lg">
      <img
        src={m.img}
        alt={m.name}
        className="w-full h-[340px] object-cover transition-transform duration-700 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B102D]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
      <div className="absolute right-4 bottom-4 flex flex-col gap-2 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
        {[Facebook, Twitter, Linkedin].map((Icon, i) => (
          <a key={i} href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white text-[#0B102D] hover:bg-[#CD0008] hover:text-white transition-colors">
            <Icon size={15} />
          </a>
        ))}
      </div>
      <span className="absolute left-4 bottom-4 w-9 h-9 flex items-center justify-center bg-[#CD0008] text-white rounded-full group-hover:opacity-0 transition-opacity">
        <Plus size={18} />
      </span>
    </div>
    <div className="text-center mt-5">
      <h3 className="font-display font-bold text-[#0B102D] text-lg">{m.name}</h3>
      <p className="text-[#CD0008] text-sm uppercase tracking-wide mt-1">{m.role}</p>
    </div>
  </div>
);

const Team = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1320px] mx-auto px-5">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="flex justify-center"><SectionLabel>Our Team</SectionLabel></div>
          <h2 className="section-heading text-[#0B102D] text-4xl md:text-5xl">
            Meet our experienced team
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-7">
          {team.map((m, i) => (
            <Reveal key={m.id} direction="up" delay={i * 120}>
              <TeamCard m={m} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
